/* A menu link "#cookie-einstellungen" opens the native Shopify cookie preferences (window.privacyBanner). */
(function () {
  var HASH = '#cookie-einstellungen';

  function isSettingsLink(link) {
    try {
      var url = new URL(link.getAttribute('href'), window.location.href);
      return url.hash === HASH && url.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function showPreferences() {
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return false;
    banner.showPreferences();
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !isSettingsLink(link)) return;
    event.preventDefault();
    if (showPreferences()) return;
    // The banner script can still be loading; try once more after the page has loaded.
    var retry = function () {
      if (!showPreferences()) console.warn('Shopify cookie preferences are not available');
    };
    if (document.readyState === 'complete') {
      setTimeout(retry, 500);
    } else {
      window.addEventListener('load', retry, { once: true });
    }
  });
})();
